import React from 'react'
import { RoomModel } from '../../common/models/RoomModel.js'
import { View } from '../view.js'
import { RoomCard } from './RoomCard.js'
import { RoomCalendar } from './RoomCalendar.js'

export interface RoomViewProps {
    room: RoomModel
    view: View
}

export function RoomView({ room, view }: RoomViewProps) {
    return (
        <div className="px-6 py-6 pb-16 flex flex-col items-center size-full">
            <div className="w-full max-w-[768px]">
                <RoomCard room={room} />
            </div>
            <div className="w-full max-w-[768px] mt-4">
                <RoomCalendar room={room} />
            </div>
        </div>
    )
}
